import { useEffect } from "react";
import { Switch, Route, Redirect, useHistory, useLocation } from "react-router-dom";
import ErrorBoundary from "./components/common/ErrorBoundary";
import { trackPage } from "./preferences/analytics";
import Home from "./pages/Home/Home";
import Tables from "./pages/Tables";
import Billing from "./pages/Billing";
import Rtl from "./pages/Rtl";
import Profile from "./pages/Home/Profile";
import SignUp from "./pages/SignUp";
import Login from "./auth/LoginView";
import Room from "./pages/Home/Room";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import "./assets/styles/app-theme.css";
import SelectEcoSystem from "./pages/SelectEcoSystem";
import Welcome from "./pages/Welcome";
import Floors from "./pages/Home/Floors";
import Devices from "./pages/Home/Devices";
import Favourites from "./pages/Home/Favourites";
import Camera from "./pages/Home/Camera";
import Extras from "./pages/Home/Extras";
import HelpCenter from "./pages/Home/HelpCenter";
import DeviceDetail from "./pages/Device/DeviceDetail";
import EditDevice from "./pages/Device/EditDevice";
import { EnergyStats, RunTimeMonitoring } from "./pages/Device/UsageStats";
import EnergyMeterGraph from "./pages/Device/EnergyMeterGraph";
import EnergyMeterExpense from "./pages/Device/EnergyMeterExpense";
import { REMOTE_ROUTES } from "./pages/Remote";
import { CAMERA_ROUTES } from "./pages/Camera";
import { SETTINGS_ROUTES } from "./pages/Device/settings";
import { SHARE_ROUTES } from "./pages/Share";
import { SECURITY_ACCESSORY_ROUTES } from "./pages/Device/security";
import { APP_SETTINGS_ROUTES } from "./pages/Settings";
import { ADMIN_ROUTES } from "./pages/Admin";
import { AUTOMATION_PATHS, AUTOMATION_ROUTES } from "./pages/Automation";

function App() {
  const history = useHistory();
  const { pathname, key } = useLocation();

  // Counts each page when the user has turned on Analytics in Settings.
  useEffect(() => {
    trackPage(pathname);
  }, [pathname]);

  // A page that's opened starts at the top, as a new screen does in the app.
  // Back and Forward (POP) leave the browser to put the person back where they
  // were.
  useEffect(() => {
    if (history.action !== "POP") window.scrollTo(0, 0);
  }, [key, history]);

  return (
    <div className="App">
      <ErrorBoundary resetKey={pathname}>
        <Switch>
          <Route path="/sign-up" exact component={SignUp} />
          <Route exact path="/SelectEcoSystem" component={SelectEcoSystem} />
          <Route exact path="/Welcome" component={Welcome} />
          <Route exact path="/Login" component={Login} />
          <Route exact path="/Property" component={Floors} />
          <Route exact path="/floors" component={Floors} />
          <Route exact path="/devices" component={Devices} />
          <Route exact path="/favourites" component={Favourites} />
          <Route exact path="/camera" component={Camera} />
          <Route exact path="/extras" component={Extras} />
          <Route exact path="/help-center" component={HelpCenter} />
          <Route exact path="/Room" component={Room} />
          <Route exact path="/dashboard" component={Home} />
          <Route exact path="/tables" component={Tables} />
          <Route exact path="/billing" component={Billing} />
          <Route exact path="/rtl" component={Rtl} />
          <Route exact path="/profile" component={Profile} />
          <Route exact path="/device" component={DeviceDetail} />
          <Route exact path="/editDevice" component={EditDevice} />
          <Route exact path="/runtime" component={RunTimeMonitoring} />
          <Route exact path="/energy-stats" component={EnergyStats} />
          <Route exact path="/energy-graph" component={EnergyMeterGraph} />
          <Route exact path="/energy-expense" component={EnergyMeterExpense} />
          {AUTOMATION_ROUTES.map((route) => (
            <Route key={route.path} exact path={route.path} component={route.component} />
          ))}
          {/* The old Schedules, Scenes and Rule Engine are Automations now
              (their API routes were retired on 2026-10-14). */}
          <Route
            exact
            path="/schedules"
            render={({ location }) => <Redirect to={{ pathname: AUTOMATION_PATHS.DEVICE, state: location.state }} />}
          />
          <Redirect exact from="/scenes" to={AUTOMATION_PATHS.HOME} />
          <Redirect exact from="/RuleEngine" to={AUTOMATION_PATHS.HOME} />
          {SETTINGS_ROUTES.map((route) => (
            <Route key={route.path} exact path={route.path} component={route.component} />
          ))}
          {REMOTE_ROUTES.map((route) => (
            <Route key={route.path} exact path={route.path} component={route.component} />
          ))}
          {CAMERA_ROUTES.map((route) => (
            <Route key={route.path} exact path={route.path} component={route.component} />
          ))}
          {SHARE_ROUTES.map((route) => (
            <Route key={route.path} exact path={route.path} component={route.component} />
          ))}
          {SECURITY_ACCESSORY_ROUTES.map((route) => (
            <Route key={route.path} exact path={route.path} component={route.component} />
          ))}
          {APP_SETTINGS_ROUTES.map((route) => (
            <Route key={route.path} exact path={route.path} component={route.component} />
          ))}
          {ADMIN_ROUTES.map((route) => (
            <Route key={route.path} exact path={route.path} component={route.component} />
          ))}
          {/* Older links to the per-kind detail pages open the same page. */}
          <Route exact path={["/switchDetail", "/SensorDetail", "/controllerDetail", "/securityDetail", "/energyMeterDetail"]} component={DeviceDetail} />
          <Redirect from="*" to="/Welcome" />
        </Switch>
      </ErrorBoundary>
    </div>
  );
}

export default App;
